import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

/**
 * Displays a modal to asks the user if they want to confirm an action.
 * @params title - string used as header title
 * @params bodyText - string or JSX displayed in the main text area of the modal
 * @params onConfirm - function called when the 'continue' or 'cancel' button is clicked
 * @returns true if the user want to continue with the action, false if cancel
 * for an example of how-to use: see location-form.jsx
 */
function ConfirmAction({
  title = "no title found",
  bodyText = "no body text found",
  onConfirm,
  show,
  cancelBtnText = "Cancel",
  continueBtnText = "Continue",
}) {
  const handleResponse = (res) => {
    onConfirm(res);
  };

  return (
    <Modal centered backdrop isOpen={show}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        {bodyText}
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => handleResponse(false)}>{cancelBtnText}</Button>
        <Button className="promote" onClick={() => handleResponse(true)}>
          {continueBtnText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmAction;
